import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHide = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 9.33333C2 6.01962 4.68629 3.33333 8 3.33333C11.3137 3.33333 14 6.01962 14 9.33333M11.3333 9.33333C11.3333 11.1743 9.84095 12.6667 8 12.6667C6.15905 12.6667 4.66667 11.1743 4.66667 9.33333C4.66667 7.49238 6.15905 5.99999 8 5.99999C9.84095 5.99999 11.3333 7.49238 11.3333 9.33333Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHide;
